import Konva from 'konva';
import React, {forwardRef} from 'react';
import {Text} from 'react-konva';

interface TextLineInterface {
  y: number;
  copy: string;
}

const TextLine = forwardRef<Konva.Text, TextLineInterface>((props, ref) => {
  return (
    <Text
      ref={ref}
      x={4}
      y={props.y + 2}
      text={props.copy}
      fontSize={16}
      fontFamily="vw-text"
      fill="black"
      background="black"
    />
  );
});

export default TextLine;
